var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDerrickAlt3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 2C2.25 1.58579 2.58579 1.25 3 1.25H13C15.0711 1.25 16.75 2.92893 16.75 5C16.75 6.78382 15.5045 8.27673 13.8357 8.65654V14.616L16.538 17.4773L17.8232 18.7626C18.5066 19.446 18.5066 20.554 17.8232 21.2374L16.5303 22.5303C16.2374 22.8232 15.7626 22.8232 15.4697 22.5303C15.1768 22.2374 15.1768 21.7626 15.4697 21.4697L16.7626 20.1768C16.8602 20.0791 16.8602 19.9209 16.7626 19.8232L15.6893 18.75H10.3107L9.23744 19.8232C9.13981 19.9209 9.13981 20.0791 9.23744 20.1768L10.5303 21.4697C10.8232 21.7626 10.8232 22.2374 10.5303 22.5303C10.2374 22.8232 9.76256 22.8232 9.46967 22.5303L8.17678 21.2374C7.49336 20.554 7.49336 19.446 8.17678 18.7626L9.46967 17.4697L9.47074 17.4686L12.3357 14.6035V8.69134C10.5815 8.37775 9.25 6.84437 9.25 5C9.25 4.1558 9.52896 3.37675 9.99973 2.75H3C2.58579 2.75 2.25 2.41421 2.25 2ZM13.0001 6.5C13.8285 6.5 14.5001 5.82843 14.5001 5C14.5001 4.17157 13.8285 3.5 13.0001 3.5C12.1716 3.5 11.5001 4.17157 11.5001 5C11.5001 5.82843 12.1716 6.5 13.0001 6.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDerrickAlt3);
export default __webpack_public_path__ + "static/media/derrick-alt-3.0aedd7acf9de64e6baef2e8df9d25523.svg";
export { ForwardRef as ReactComponent };